import { render, staticRenderFns } from "./portfolioDS.vue?vue&type=template&id=7c0dd4f6"
import script from "./portfolioDS.vue?vue&type=script&lang=js"
export * from "./portfolioDS.vue?vue&type=script&lang=js"
import style0 from "./portfolioDS.vue?vue&type=style&index=0&id=7c0dd4f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports